<template>
  <div>
    <p class="rights" v-if="!isPermissions.support_payments && !isPermissions.read_user_items">
      Not enough rights
    </p>
    <div class="searchPanel" v-if="isPermissions.support_payments">
      <div class="searchPanel__input">
        <div class="searchPanel__input__label">Id in project:</div>
        <div class="searchPanel__input-wrapper">
          <input type="text" placeholder="Id:" @input="onChangeIdInputProject" />
        </div>
      </div>
      <div class="searchPanel__input">
        <div class="searchPanel__input__label">Wallet:</div>
        <div class="searchPanel__input-wrapper">
          <input type="text" placeholder="Wallet:" @input="onChangeInputWallet" />
        </div>
      </div>
      <div class="searchPanel__input">
        <div class="searchPanel__input__label">UserId:</div>
        <div class="searchPanel__input-wrapper">
          <input type="text" placeholder="UserId:" @input="onChangeInputUserId" />
        </div>
      </div>
      <div class="searchPanel__input">
        <div class="searchPanel__input__label">Status:</div>
        <div class="searchPanel__input-wrapper">
          <input type="text" placeholder="Status:" @input="onChangeInputStatus" />
        </div>
      </div>
      <div class="searchPanel__input calendarInput">
        <div class="searchPanel__input__label">Date:</div>
        <div id="app" class="searchPanel__calendar">
          <DatePicker
            v-on:input="getCorrectDate"
            v-bind:value="selectedDate"
            is-dark
            is-range
            v-if="openedCalendar"
            :modelConfig="modelConfig"
            :select-attribute="selectDragAttribute"
            :drag-attribute="selectDragAttribute"
            @drag="dragValue = $event"
          >
            <template v-slot:day-popover="{ format }">
              <div>
                {{ format(dragValue ? dragValue.start : range.start, 'MMM D') }}
                -
                {{ format(dragValue ? dragValue.end : range.end, 'MMM D') }}
              </div>
            </template>
          </DatePicker>
        </div>
        <div class="searchPanel__input-wrapper searchPanel__calendarValue" @click="openCalendar">
          <span>{{ valueDate }}</span>
          <button class="clear" @click="clearDate">Clear</button>
        </div>
      </div>
      <div class="searchPanel__input">
        <div class="searchPanel__input__label">Id in payment:</div>
        <div class="searchPanel__input-wrapper">
          <input type="text" placeholder="PaymentId:" @input="onChangeInputIdPayment" />
        </div>
      </div>
      <div class="searchPanel__input">
        <div class="searchPanel__input__label">Currency:</div>
        <div class="searchPanel__input-wrapper">
          <select v-model="currency">
            <option value="">All</option>
            <option value="&currency=rub">rub</option>
            <option value="&currency=usd">usd</option>
            <option value="&currency=eur">eur</option>
          </select>
        </div>
      </div>
      <div class="searchPanel__input">
        <div class="searchPanel__input__label">Method:</div>
        <div class="searchPanel__input-wrapper">
          <input type="text" placeholder="Method:" @input="onChangeInputIdMethod" />
        </div>
      </div>
      <div class="searchPanel__input">
        <div class="searchPanel__input__label">Payment system:</div>
        <div class="searchPanel__input-wrapper">
          <select v-model="paymentSystem">
            <option value="">All</option>
            <option value="&payment_system=gm">Gm</option>
            <option value="&payment_system=payok">Payok</option>
            <option value="&payment_system=fkwallet">Fkwallet</option>
          </select>
        </div>
      </div>
      <div class="checkbox" v-if="isPermissions.admin_payments">
        <span :class="{ active: cheackIsAdmin }" @click="cheackCheckbox">Is Admin</span>
      </div>
      <div class="checkbox" v-if="isPermissions.admin_payments && isPermissions.acc_once_payments">
        <span :class="{ active: isAccounting }" @click="accountingCheckBox">Accounting</span>
      </div>
      <div class="searchButton">
        <button @click="searchFilter">
          <img src="../../assets/images/search.svg" alt="" />
          <span>Search</span>
        </button>
      </div>
    </div>
    <!--      <div class="filter">-->
    <!--        <div class="filter-wrapper">-->
    <!--          <div class="left-block">-->
    <!--            <div class="left-block__droptext">-->
    <!--              <div-->
    <!--                class="droptext__wrapper"-->
    <!--                @click="isOpenFilter = !isOpenFilter"-->
    <!--              >-->
    <!--                <p class="left-block__droptext-text">{{ searchType }}</p>-->
    <!--                <img src="../../assets/images/arrow-down.svg" alt="" />-->
    <!--              </div>-->
    <!--              <ul-->
    <!--                class="left-block__droptext-block"-->
    <!--                :class="{ openDropMenu: isOpenFilter }"-->
    <!--              >-->
    <!--                <li v-if="searchType !== 'ID ВЫВОДА'" @click="toggleSearchType">-->
    <!--                  ID ВЫВОДА-->
    <!--                </li>-->
    <!--                <li v-if="searchType !== 'USER ID'" @click="toggleSearchType">-->
    <!--                  USER ID-->
    <!--                </li>-->
    <!--                <li @click="toggleSearchType" v-if="searchType !== 'КОШЕЛЁК'">-->
    <!--                  КОШЕЛЁК-->
    <!--                </li>-->
    <!--                <li @click="toggleSearchType" v-if="searchType !== 'СТАТУС'">-->
    <!--                  СТАТУС-->
    <!--                </li>-->
    <!--              </ul>-->
    <!--            </div>-->
    <!--            <div class="left-block__input">-->
    <!--              <input-->
    <!--                type="text"-->
    <!--                v-model="search"-->
    <!--                @keydown.enter="serachRecords"-->
    <!--              />-->
    <!--              <div class="icon-search" @click="serachRecords">-->
    <!--                <img src="../../assets/images/search.svg" alt="" />-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <div class="content-wrapper" v-if="isPermissions.support_payments">
      <div class="loader-block" v-if="!isLoaded">
        <Loader />
      </div>
      <div
        class="content-wrapper__table"
        :class="{ nothing: records.length === 0 }"
        v-if="isLoaded"
      >
        <table>
          <thead>
            <tr
              :class="{
                accountingSearch: accountingSearch,
                control: !accountingSearch && isPermissions.moderator_payments
              }"
            >
              <td class="moreTd"></td>
              <td v-if="accountingSearch">Accounting</td>
              <td class="id">ID withdraw</td>
              <!--                <td class="name">Name</td>-->
              <!--                <td class="secondName">Second name</td>-->
              <!-- <td>ВАЛЮТА</td> -->
              <td class="wallet">Wallet</td>
              <td class="userId">USER ID</td>
              <td class="source">source</td>
              <td>final</td>
              <td>Status</td>
              <td>Method</td>
              <td v-if="!accountingSearch && isPermissions.moderator_payments">Control</td>
              <td v-if="!accountingSearch">Description</td>
              <td>Date</td>
              <td>Agree</td>
            </tr>
          </thead>
          <tbody>
            <tr
              is="Tabel-Row"
              v-for="record in records"
              :key="record.id"
              :permission="isPermissions.moderator_payments"
              v-bind:record="record"
              v-bind:accountingSearch="accountingSearch"
              @updateRecords="updateData"
            />
          </tbody>
          <p v-if="records.length === 0" class="nothingInfo">No withdraw</p>
        </table>
      </div>
    </div>
    <div class="bottom-wrapper" v-if="isPermissions.moderator_payments">
      <div class="bottom-wrapper__info">
        <p>Страница {{ pageNumber }} из {{ totalPagesCount }} записей</p>
      </div>
      <div class="bottom-wrapper__pag">
        <div
          class="bottom-wrapper__pag-prev"
          :class="{ disable: pageNumber === 1 }"
          @click="changePage(-1)"
        >
          <svg
            width="9"
            height="15"
            viewBox="0 0 9 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.81251 8.23954L6.70834 14.125C6.80518 14.2226 6.92039 14.3001 7.04732 14.353C7.17426 14.4058 7.31041 14.4331 7.44793 14.4331C7.58544 14.4331 7.72159 14.4058 7.84853 14.353C7.97546 14.3001 8.09067 14.2226 8.18751 14.125C8.38152 13.9298 8.49042 13.6658 8.49042 13.3906C8.49042 13.1154 8.38152 12.8514 8.18751 12.6562L3.03126 7.44787L8.18751 2.29162C8.38152 2.09645 8.49042 1.83244 8.49042 1.55725C8.49042 1.28205 8.38152 1.01804 8.18751 0.822872C8.09104 0.724447 7.97599 0.646145 7.84904 0.592503C7.72208 0.53886 7.58575 0.510945 7.44793 0.510373C7.31011 0.510945 7.17377 0.53886 7.04682 0.592502C6.91986 0.646145 6.80482 0.724447 6.70834 0.822872L0.81251 6.70829C0.706775 6.80583 0.622391 6.92422 0.564675 7.05599C0.50696 7.18776 0.477163 7.33006 0.477163 7.47391C0.477163 7.61777 0.50696 7.76006 0.564675 7.89183C0.622391 8.0236 0.706775 8.14199 0.81251 8.23954Z"
              fill="#B8B8B8"
            />
          </svg>
        </div>
        <div class="bottom-wrapper__pag-items"></div>
        <div
          class="bottom-wrapper__pag-next"
          :class="{ disable: pageNumber === totalPagesCount }"
          @click="changePage(1)"
        >
          <svg
            width="9"
            height="15"
            viewBox="0 0 9 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.18751 8.23954L2.29168 14.125C2.19484 14.2226 2.07964 14.3001 1.9527 14.353C1.82576 14.4058 1.68961 14.4331 1.5521 14.4331C1.41459 14.4331 1.27843 14.4058 1.1515 14.353C1.02456 14.3001 0.909351 14.2226 0.812514 14.125C0.618503 13.9298 0.509605 13.6658 0.509605 13.3906C0.509605 13.1154 0.618503 12.8514 0.812514 12.6562L5.96876 7.44787L0.812513 2.29162C0.618502 2.09645 0.509604 1.83244 0.509604 1.55725C0.509604 1.28205 0.618502 1.01804 0.812513 0.822872C0.908987 0.724447 1.02403 0.646145 1.15099 0.592503C1.27794 0.53886 1.41428 0.510945 1.5521 0.510373C1.68992 0.510945 1.82625 0.53886 1.95321 0.592502C2.08016 0.646145 2.19521 0.724447 2.29168 0.822872L8.18751 6.70829C8.29325 6.80583 8.37763 6.92422 8.43535 7.05599C8.49306 7.18776 8.52286 7.33006 8.52286 7.47391C8.52286 7.61777 8.49306 7.76006 8.43535 7.89183C8.37763 8.0236 8.29325 8.14199 8.18751 8.23954Z"
              fill="#B8B8B8"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './main.scss'

import Loader from '@/components/Loader/Loader.vue'
import TabelRow from '@/components/TabelRow/TabelRow.vue'
import { DatePicker, Calendar } from 'v-calendar'

export default {
  name: 'Home',
  components: {
    TabelRow,
    Loader,
    Calendar,
    DatePicker
  },
  data() {
    return {
      dragValue: null,
      range: {
        start: new Date(2018, 0, 8),
        end: new Date(2018, 0, 12)
      },
      modelConfig: {
        type: 'string',
        mask: 'iso'
      },
      selectedDate: new Date(),
      startDate: '',
      endDate: '',
      isLoaded: false,
      isOpenFilter: false,
      valueDate: 'Select a date',
      pageNumber: 1,
      totalPagesCount: 0,
      countRecords: 15,
      records: [],
      idProject: '',
      wallet: '',
      userId: '',
      status: '',
      idPayment: '',
      method: '',
      currency: '',
      paymentSystem: '',
      isAdmin: '',
      isAccounting: '',
      openedCalendar: false,
      accountingSearch: false,
      cheackIsAdmin: false
    }
  },
  created() {
    this.initListeners()
  },
  destroyed() {
    this.initListeners()
  },
  mounted() {
    this.getAdminInfo()
  },
  computed: {
    isToggleSideBar() {
      return this.$store.state.toggleSideBar
    },
    isPermissions() {
      return this.$store.state.permissions
    },
    isDailyLimit() {
      return this.$store.state.currentDailyLimit
    },
    selectDragAttribute() {
      return {
        popover: {
          visibility: 'hover',
          isInteractive: false
        }
      }
    }
  },
  methods: {
    getAdminInfo() {
      if (this.isPermissions.admin_payments) {
        this.cheackCheckbox()
        // this.getWithdrawSum()
      }
      this.updateData()
    },
    // getAdminStatus () {
    //   fetch(
    //           `https://auth.apineural.com/api/user/admin-status`,
    //           {
    //             method: "GET",
    //             headers: {
    //               Authorization: `Bearer ${this.$store.state.tokens.access}`,
    //             },
    //           }
    //   )
    //           .then((res) => {
    //             if (res.status === 401) {
    //               cookie.delete("token");
    //               cookie.delete("refresh");
    //               this.$router.push("/");
    //             }
    //             return res.json()
    //           })
    //           .then((data) => {
    //             const limit = data.payments_limit
    //             const itemsLimit = data.items_limit
    //             const permissions = data.permissions
    //             this.$store.commit("setDailyLimit", limit )
    //             this.$store.commit("setItemsExchangeLimit", itemsLimit)
    //             this.$store.commit("setPermissions", permissions)
    //             if (permissions.admin_payments) {
    //               this.cheackCheckbox()
    //               this.getWithdrawSum()
    //             }
    //             this.updateData();
    //           });
    // },
    // getWithdrawSum () {
    //   fetch(
    //           `https://payments.neuralgeneration.com/api/v1/withdrawals/admin-withdrawals-sum`,
    //           {
    //             method: "GET",
    //             headers: {
    //               Authorization: `Bearer ${this.$store.state.tokens.access}`,
    //             },
    //           }
    //   )
    //           .then((res) => res.json())
    //           .then((data) => {
    //             const currentDailyLimit = {}
    //             for (const [key, value] of Object.entries(data)) {
    //               currentDailyLimit[key] = this.isDailyLimit[key] - value
    //             }
    //             this.$store.commit("setCurrentDailyLimit", currentDailyLimit )
    //           });
    // },
    getCorrectDate(e) {
      this.startDate = `&from_datetime=${e.start.split('.')[0]}`
      this.endDate = `&to_datetime=${e.end.split('.')[0]}`
      this.valueDate = `${e.start.split('T')[0]} - ${e.end.split('T')[0]}`
      this.openedCalendar = false
    },
    clearDate() {
      this.startDate = ''
      this.endDate = ''
      this.valueDate = 'Select a date'
    },
    closeByClickingOut(event) {
      const path = event.path || (event.composedPath && event.composedPath())
      if (
        event &&
        !path.find(
          (div) =>
            div.classList &&
            (div.classList.contains('searchPanel__calendar') ||
              div.classList.contains('calendarInput'))
        )
      ) {
        this.openedCalendar = false
      }
    },
    initListeners() {
      document.addEventListener('click', this.closeByClickingOut)
    },
    getAllItems() {
      this.isLoaded = false
      fetch(
        `https://payments.neuralgeneration.com/api/v1/withdrawals/fetch_all?page=${this.pageNumber}&count=${this.countRecords}${this.isAdmin}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${this.$store.state.tokens.access}`
          }
        }
      )
        .then((res) => res.json())
        .then((data) => {
          this.records = data.withdrawals
          this.totalPagesCount = data.totalPagesCount
          this.addWithdrawalMethodsName()
        })
    },
    openCalendar(event) {
      const path = event.path || (event.composedPath && event.composedPath())
      if (event && path.find((button) => button.classList && button.classList.contains('clear'))) {
      } else {
        this.openedCalendar = true
      }
    },
    onChangeIdInputProject(e) {
      if (e.target.value) {
        this.idProject = `&id=${e.target.value}`
      } else {
        this.idProject = ''
      }
    },
    onChangeInputWallet(e) {
      if (e.target.value) {
        this.wallet = `&wallet=${encodeURIComponent(e.target.value)}`
      } else {
        this.wallet = ''
      }
    },
    onChangeInputUserId(e) {
      if (e.target.value) {
        this.userId = `&userId=${e.target.value}`
      } else {
        this.userId = ''
      }
    },
    onChangeInputStatus(e) {
      if (e.target.value) {
        this.status = `&status=${e.target.value}`
      } else {
        this.status = ''
      }
    },
    onChangeInputIdPayment(e) {
      if (e.target.value) {
        this.idPayment = `&payment_system_invoice=${e.target.value}`
      } else {
        this.idPayment = ''
      }
    },
    onChangeInputIdMethod(e) {
      if (e.target.value) {
        this.method = `&method=${e.target.value}`
      } else {
        this.method = ''
      }
    },
    cheackCheckbox() {
      this.cheackIsAdmin = !this.cheackIsAdmin
      this.isAdmin = `&is_admin=${this.cheackIsAdmin}`
    },
    accountingCheckBox() {
      if (!this.isAccounting) {
        this.isAccounting = `&accounting=true`
      } else {
        this.isAccounting = ''
      }
    },
    searchFilter() {
      this.isLoaded = false
      if (this.isAccounting) {
        this.accountingSearch = true
      } else {
        this.accountingSearch = false
      }
      fetch(
        `https://payments.neuralgeneration.com/api/v1/withdrawals/fetch_all?page=${this.pageNumber}&count=${this.countRecords}${this.idProject}${this.wallet}${this.userId}${this.status}${this.idPayment}${this.method}${this.currency}${this.paymentSystem}${this.startDate}${this.endDate}${this.isAdmin}${this.isAccounting}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${this.$store.state.tokens.access}`
          }
        }
      )
        .then((res) => res.json())
        .then((data) => {
          this.records = data.withdrawals
          this.totalPagesCount = data.totalPagesCount
          this.addWithdrawalMethodsName()
        })
    },
    changePage(direction) {
      this.isLoaded = false
      if (direction + this.pageNumber <= this.totalPagesCount && direction === 1) {
        this.pageNumber += 1
      } else if (direction + this.pageNumber > 0 && direction === -1) {
        this.pageNumber -= 1
      }
      this.searchFilter()
    },
    updateData() {
      this.getAllItems()
    },
    addWithdrawalMethodsName() {
      fetch(`https://payments.neuralgeneration.com/api/v1/withdrawals/methods/fetch_all`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.$store.state.tokens.access}`
        }
      })
        .then((res) => res.json())
        .then((data) => {
          data.withdrawalMethods.forEach((item) => {
            this.records.forEach((record) => {
              if (record.withdrawalMethodId === item.id) {
                record['name'] = item.name
                record['withdrawal_method_ps'] = data.withdrawalPaymentSystems[item.name][0]
              }
            })
          })
          this.isLoaded = true
        })
    }
  }
}
</script>
